import React from "react";
import { ModuleWrapper } from "components/fragments";
import { HeaderA } from "components/headers";
import lang from "translations";

const StockTransfers = () => {
  return (
    <ModuleWrapper
      header={
        <HeaderA title={lang.stockTransfers} />
      }
    >
    </ModuleWrapper>
  );
};

export default StockTransfers;
